// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth} from 'firebase/auth';
import {getFirestore} from 'firebase/firestore'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCrtfHNh0akv8uIt0Gmhs2ibMKIuOU9MWo",
  authDomain: "moviehinge.firebaseapp.com",
  projectId: "moviehinge",
  storageBucket: "moviehinge.appspot.com",
  messagingSenderId: "962019041284",
  appId: "1:962019041284:web:c68077ce7cf8926aa5d551",
  measurementId: "G-PSTP8STRT3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app)

export { auth,db };